export const API_BASE_URL = "https://shifdo.co.in/api/";
